import { Outlet } from "react-router-dom";

export default function Dashboards() {
    return <Outlet />;
}
